(function () {
  const drawer = document.querySelector('[data-drawer]');
  const overlay = document.querySelector('[data-overlay]');
  if (!drawer || !overlay) return;

  const triggers = document.querySelectorAll('.echo-header__trigger');
  const closeBtn = drawer.querySelector('[data-close]');
  const title = drawer.querySelector('[data-title]');
  const panels = drawer.querySelectorAll('.echo-panel');
  const tabs = drawer.querySelectorAll('.alt-echo-tab'); // tabs we added
  const mqDesktop = window.matchMedia('(min-width: 990px)');

  let lastFocus = null;

  function setActiveTab(name) {
    tabs.forEach(t => {
      const active = t.getAttribute('data-switch') === name;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  }

  function setActivePanel(name) {
    panels.forEach(p => {
      const match = p.getAttribute('data-panel') === name;
      p.hidden = !match;
      if (match) p.focus({ preventScroll: true });
    });
    title.textContent = name ? name.toUpperCase() : 'Menu';
    setActiveTab(name);
  }

  function openDrawer(panelName) {
    drawer.hidden = false;
    overlay.hidden = false;
    requestAnimationFrame(() => {
      drawer.classList.add('is-active');
      overlay.classList.add('is-active');
    });
    document.documentElement.style.overflow = 'hidden';
    setActivePanel(panelName);
    drawer.setAttribute('aria-hidden', 'false');

    // focus trap start
    lastFocus = document.activeElement;
    (drawer.querySelector('[tabindex="-1"]') || drawer).focus({ preventScroll: true });
  }

  function closeDrawer() {
    drawer.classList.remove('is-active');
    overlay.classList.remove('is-active');
    document.documentElement.style.overflow = '';
    drawer.setAttribute('aria-hidden', 'true');
    setTimeout(() => { drawer.hidden = true; overlay.hidden = true; }, 300);
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }

  // Desktop triggers -> open drawer on that panel
  triggers.forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      openDrawer(btn.getAttribute('data-panel'));
    });
  });

  // Single delegated click handler for everything inside the drawer
  drawer.addEventListener('click', (e) => {
    // 1) Tab switching
    const tabBtn = e.target.closest('[data-switch]');
    if (tabBtn) {
      e.preventDefault();
      const name = tabBtn.getAttribute('data-switch');
      if (drawer.hidden) openDrawer(name); else setActivePanel(name);
      return; // stop here so it won't fall through to accordion logic
    }

    // 2) Accordion toggles
    const accBtn = e.target.closest('[data-accordion]');
    if (accBtn) {
      e.preventDefault();
      const expanded = accBtn.getAttribute('aria-expanded') === 'true';
      accBtn.setAttribute('aria-expanded', String(!expanded));

      // Next sibling must be the UL we want to show/hide
      const nextUL = accBtn.nextElementSibling;
      if (nextUL && nextUL.tagName === 'UL') {
        nextUL.hidden = expanded; // if it was open, hide; if it was closed, show
      }
    }
  });

  // Close interactions
  overlay.addEventListener('click', closeDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !drawer.hidden) closeDrawer();
  });

  // Close when clicking anywhere outside the drawer (desktop only)
  // Track whether we just closed so we can swallow the subsequent click
  let justClosed = false;

  document.addEventListener('pointerdown', (e) => {
    if (drawer.hidden) return;
    if (!mqDesktop.matches) return;
    if (drawer.contains(e.target)) return;
    if (e.target.closest('.echo-header__trigger')) return;
    justClosed = true;
    closeDrawer();
  });

  document.addEventListener('click', (e) => {
    if (justClosed) {
      e.preventDefault();
      e.stopImmediatePropagation();
      justClosed = false;
    }
  }, true);

  // On breakpoint changes, close any open drawer to avoid odd states
  mqDesktop.addEventListener('change', () => { if (!drawer.hidden) closeDrawer(); });
})();

